import { Component, inject, input, linkedSignal, model, OnInit, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { provideIcons } from '@ng-icons/core';
import { lucideChevronDown, lucideSearch, lucideX } from '@ng-icons/lucide';
import { BrnSelectImports } from '@spartan-ng/brain/select';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmButtonGroupImports } from '@spartan-ng/helm/button-group';
import { HlmIconImports } from '@spartan-ng/helm/icon';
import { HlmInputImports } from '@spartan-ng/helm/input';
import { HlmInputGroupImports } from '@spartan-ng/helm/input-group';
import { HlmSelectImports } from '@spartan-ng/helm/select';

import { TrierParPipe } from '../../pipes/trier-par.pipe';
import { Référentiel } from '../../../administration/gestion-référentiels/models/référentiel.model';
import { ReferentielStore } from '../../../administration/gestion-référentiels/store/referentiel.store';

@Component({
  selector: 'app-input-search-filter',
  imports: [
    HlmIconImports,
    HlmSelectImports,
    BrnSelectImports,
    HlmInputImports,
    HlmButtonImports,
    TrierParPipe,
    FormsModule,
    HlmButtonGroupImports,
    HlmInputGroupImports,
  ],
  templateUrl: './input-search-filter.component.html',
  providers: [
    provideIcons({
      lucideChevronDown,
      lucideSearch,
      lucideX,
    }),
  ],
})
export class InputSearchFilterComponent implements OnInit {
  readonly #referentielStore = inject(ReferentielStore);
  readonly referentiels = linkedSignal(() => this.#referentielStore.referentielsActifs());

  readonly filtre = model<string>('');
  readonly placeholder = input.required<string>();
  readonly referentielCourant = input<Référentiel>();
  readonly referentiel = linkedSignal<Référentiel | undefined>(() => this.referentielCourant());
  onFilter = output<{ filtre: string; idReferentiel?: string }>();

  ngOnInit(): void {
    this.filtrer();
  }

  setReferentiel(referentiel?: Référentiel) {
    this.referentiel.set(referentiel);
    this.filtrer();
  }

  filtrer() {
    this.onFilter.emit({
      filtre: this.filtre(),
      idReferentiel: this.referentiel()?.id,
    });
  }

  emptyFilter() {
    this.filtre.set('');
  }
}
